import Vue from 'vue'
import RootCacheMixin from 'GroomyRoot/mixins/Cache.js'

export default Vue.util.mergeOptions(RootCacheMixin, {
    methods: {
        
    }
})